'use client'

import { motion } from 'framer-motion'
import { BookOpen, ShieldCheck, Truck, MessageSquareQuote, Sparkles, Zap } from 'lucide-react'
import { Container } from '@/components/ui/container'
import { Section } from '@/components/ui/section'

const knowledge = [
  { icon: BookOpen, label: 'All product pages' },
  { icon: ShieldCheck, label: 'Policies' },
  { icon: Truck, label: 'Shipping & returns' },
  { icon: MessageSquareQuote, label: 'FAQs' },
  { icon: Sparkles, label: 'Brand tone' },
  { icon: Zap, label: 'Product positioning' },
]

export function AutonomousIntelligenceSection() {
  return (
    <Section background="dark">
      <Container>
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="order-2 lg:order-1"
          >
            <div className="grid grid-cols-2 sm:grid-cols-3 gap-4">
              {knowledge.map((item, index) => {
                const Icon = item.icon
                return (
                  <motion.div
                    key={item.label}
                    initial={{ opacity: 0, y: 10 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ delay: index * 0.05 }}
                    className="p-4 rounded-xl bg-panel border border-line text-center hover:border-brand-violet-line transition-colors"
                  >
                    <Icon className="w-6 h-6 text-brand-violet mx-auto mb-2" />
                    <span className="text-xs font-medium text-muted">{item.label}</span>
                  </motion.div>
                )
              })}
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="order-1 lg:order-2"
          >
            <p className="text-micro-uppercase text-brand-violet mb-3">AUTONOMOUS STORE INTELLIGENCE</p>
            <h2 className="text-display-1 text-ink mb-4">
              Your store’s knowledge.
              A more helpful conversation.
            </h2>
            <p className="text-body-lg text-muted mb-6">
              Buddy AI reads your store like a human sales rep would. No flows, no scripting, no manual AI training. Connect your store to give Buddy product information, policies, and your brand’s context.
            </p>

            <div className="grid sm:grid-cols-2 gap-4">
              {[
                'Auto-syncs with product catalog',
                'Reads shipping & return policies',
                'Matches your brand tone',
                'You review suggestions from Insights',
              ].map((item) => (
                <div key={item} className="flex items-start gap-2 text-sm text-muted">
                  <span className="w-1.5 h-1.5 rounded-full bg-brand-violet mt-1.5 flex-shrink-0" />
                  {item}
                </div>
              ))}
            </div>
          </motion.div>
        </div>
      </Container>
    </Section>
  )
}
